<template>
    <div class="avatar-widget text-center">
        <div class="avatar-widget-avatar">
            <div class="avatar" :style="style">
                <span v-if="colorpicker" class="avatar-widget-avatar-picker"
                      :style="{ 'background-color': selectedColor }" @click="toggleColorPicker"></span>
                <color-picker v-if="colorpicker" v-model="selectedColor"></color-picker>
            </div>
        </div>
        <input style="display: none"
               ref="fileInput"
               type="file"
               @change="changeFile"
               accept="image/*"/>

        <div class="button-wrapper-center margin-top-20" v-if="upload === true">
            <button v-if="file || value"
                    :class="{ 'button-warn': true, 'loading': loadingRemove }"
                    @click="remove"><span class="icon icon-trash" aria-hidden="true"></span>
            </button>
            <button v-else
                    :class="{ 'button-full': true, 'loading': loading }"
                    @click="open">{{ $t('button.upload') }}

            </button>
        </div>
    </div>
</template>

<script>
  import ColorPicker from '@/components/widgets/ColorPickerWidget'
  export default {
    name: 'AvatarWidget',
    components: {ColorPicker},
    props: ['value', 'color', 'colorpicker', 'url', 'upload'],
    data () {
      return {
        defaultImage: '/static/images/default-avatar.svg',
        image: null,

        loading: false,
        loadingRemove: false,

        file: null,
        selectedColor: this.color
      }
    },
    watch: {
      selectedColor (value) {
        this.$emit('colorChanged', value)
      },
      file () {
        if (this.url) {
          if (!this.file) {
            return
          }

          this.loading = true
          let $this = this
          let fileData = new FormData()
          fileData.append('image', this.file)
          this.$api.post(this.url, fileData, {
            'Content-Type': 'multipart/form-data'
          }).then(response => {
            this.loadFilePreview(() => {
              $this.loading = false
              $this.$emit('input', response.data.data.image)
            })
          }).catch(() => {
            this.loading = false
            this.$events.fire('message-open', {
              type: 'error',
              message: this.$t('message.saveFailed')
            })
          })
        } else {
          if (this.file) {
            this.loadFilePreview()
          }
          this.$emit('input', this.file)
        }
      }
    },
    computed: {
      style () {
        let style = {}
        if (this.selectedColor) {
          style.borderColor = this.selectedColor
        }

        let image = this.defaultImage

        if (this.value) {
          image = this.value + '/w=200'
        }

        if (this.image) {
          image = this.image
        }

        style.backgroundImage = 'url(' + image + ')'
        return style
      }
    },
    methods: {
      open () {
        this.$refs.fileInput.click()
      },
      toggleColorPicker () {
        this.$events.fire('colorpicker-toggle')
      },
      changeFile (e) {
        let files = e.target.files
        if (!files.length) return
        this.file = files[0]
      },
      loadFilePreview (callback) {
        let reader = new FileReader()
        let scope = this
        reader.onload = function (e) {
          if (callback) {
            callback(e)
          }
          scope.image = e.target.result
        }
        reader.readAsDataURL(this.file)
      },
      remove () {
        if (this.url) {
          this.loadingRemove = true
          this.$api.delete(this.url).then(() => {
            this.loadingRemove = false
            this.image = null
            this.file = null
            this.$emit('input', null)
          }).catch(() => {
            this.loadingRemove = false
            this.$events.fire('message-open', {
              type: 'error',
              message: this.$t('message.somethingWentWrong')
            })
          })
        } else {
          this.file = null
          this.image = null
          this.$refs.fileInput.value = null
          this.$emit('input', null)
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/widgets/AvatarWidget.vue